/**
 * The prototype's `.stsel`: a select whose own colour carries its state, so a
 * classification or status reads at a glance down a dense column without a
 * separate badge cell. Tone is driven by `data-tone`, which callers map from
 * their domain value — the raw domain codes never appear as selectors here.
 */
.stsel {
  width: 100%;
  padding: 6px 26px 6px var(--sp-3);
  border: 1px solid var(--line2);
  border-radius: 7px;
  background-color: var(--bg2);
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%239DB0AC' stroke-width='1.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 9px center;
  color: var(--text2);
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  appearance: none;
  transition: var(--transition);
}
.stsel:focus {
  border-color: var(--magenta);
  outline: none;
}
.stsel:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.stsel[data-tone='success'] {
  border-color: color-mix(in srgb, var(--lime) 50%, transparent);
  background-color: color-mix(in srgb, var(--lime) 12%, transparent);
  color: var(--text-success);
}
.stsel[data-tone='danger'] {
  border-color: color-mix(in srgb, var(--magenta) 50%, transparent);
  background-color: color-mix(in srgb, var(--magenta) 12%, transparent);
  color: var(--magenta);
}
.stsel[data-tone='warn'] {
  border-color: color-mix(in srgb, var(--amber) 50%, transparent);
  background-color: color-mix(in srgb, var(--amber) 12%, transparent);
  color: var(--text-warn);
}
.stsel[data-tone='info'] {
  border-color: color-mix(in srgb, var(--aqua) 50%, transparent);
  background-color: color-mix(in srgb, var(--aqua) 12%, transparent);
  color: var(--text-info);
}
.stsel[data-tone='idle'] {
  border-color: var(--line2);
  color: var(--sage);
}
